import { X, ShareNetwork, MapPin, WifiSlash, Bell, Flag, BatteryHigh } from "@phosphor-icons/react";

const STEPS = [
  {
    icon: ShareNetwork,
    title: "Share one code",
    body: "Everyone types the SAME group code. Anyone with that code shows up on your map — no sign-up, no adding contacts.",
  },
  {
    icon: MapPin,
    title: "You're a live dot",
    body: "Your phone's GPS drops your dot on the satellite map. Friends see it move, with a little 'updated 20s ago' under each name.",
  },
  {
    icon: WifiSlash,
    title: "Works with bad signal",
    body: "Lost service? You still see everyone's LAST known spot (marked 'last seen 5m ago'). It all catches up the second you get a bar.",
  },
  {
    icon: Bell,
    title: "Buzz a friend",
    body: "Tap a friend's dot (or the bell next to their name) to make their phone buzz — a nudge to check the map and find you.",
  },
  {
    icon: Flag,
    title: "Drop a meet point",
    body: "Tap 'Drop Meet Point', then tap the map. Everyone gets asked 'coming?' and sees who's on the way + how long to walk there.",
  },
  {
    icon: BatteryHigh,
    title: "Save battery & map",
    body: "Flip on Battery Saver to update less often, and hit 'Save Map' so the map still shows even with zero signal.",
  },
];

export default function HowItWorks({ open, onClose }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[80] flex items-end justify-center bg-black/60 sm:items-center" data-testid="how-it-works">
      <div className="flex max-h-[90vh] w-full max-w-md flex-col border-2 border-black bg-white shadow-[8px_8px_0px_rgba(0,0,0,1)]">
        <div className="flex items-center justify-between border-b-2 border-black bg-secondary px-4 py-3 text-white">
          <h2 className="font-heading text-lg font-black uppercase tracking-tight">How it works</h2>
          <button data-testid="how-it-works-close" onClick={onClose} className="grid h-9 w-9 place-items-center border-2 border-black bg-primary text-black">
            <X weight="bold" size={18} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-4">
          <p className="mb-4 font-mono2 text-sm font-medium text-black/60">
            Find your crew in seconds. Here's the whole thing:
          </p>
          <div className="flex flex-col gap-3">
            {STEPS.map((s, i) => {
              const Icon = s.icon;
              return (
                <div key={i} className="flex gap-3 border-2 border-black bg-background p-3 shadow-[3px_3px_0px_rgba(0,0,0,1)]">
                  <span className="grid h-10 w-10 shrink-0 place-items-center border-2 border-black bg-primary text-black">
                    <Icon weight="bold" size={20} />
                  </span>
                  <div>
                    <p className="font-heading text-sm font-bold uppercase leading-tight">
                      <span className="mr-1 text-accent">{i + 1}.</span>{s.title}
                    </p>
                    <p className="mt-1 font-mono2 text-xs font-medium leading-snug text-black/70">{s.body}</p>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="mt-4 border-2 border-black bg-accent p-3 text-white shadow-[3px_3px_0px_rgba(0,0,0,1)]">
            <p className="font-heading text-xs font-bold uppercase">Pro tip for the crew</p>
            <p className="mt-1 font-mono2 text-xs font-medium leading-snug">
              Screenshot the group code and send it to the group chat before you split up. Everyone types it in and you're all on the same map.
            </p>
          </div>
        </div>

        <div className="border-t-2 border-black p-4">
          <button
            data-testid="how-it-works-got-it"
            onClick={onClose}
            className="h-14 w-full border-2 border-black bg-primary font-heading text-base font-bold uppercase shadow-[4px_4px_0px_#18181B] transition-transform duration-150 ease-out active:translate-x-[3px] active:translate-y-[3px] active:shadow-none"
          >
            Got it — let's go
          </button>
        </div>
      </div>
    </div>
  );
}
